import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TranslateModule } from '@ngx-translate/core';


import { BrandingAngularModule } from 'rev-portal/branding/BrandingAngular.Module';
import { ButtonsAngularModule } from 'rev-shared/ui/buttons/ButtonsAngular.Module';
import { CheckboxAngularModule } from 'rev-shared/ui/checkbox/CheckboxAngular.Module';
import { CssRulesAngularModule } from 'rev-shared/ui/css/Css.AngularModule';
import { DateAngularModule } from 'rev-shared/date/DateAngular.Module';
import { DialogAngularModule } from 'rev-shared/ui/dialog/DialogAngular.Module';
import { DialogRegistrationService } from 'rev-shared/ui/dialog/DialogRegistration.Service';
import { DirectivesAngularModule } from 'rev-shared/util/directives/DirectivesAngular.Module';
import { FormDirectivesAngularModule } from 'rev-shared/util/directives/form/FormDirectivesAngular.Module';
import { FormGroupAngularModule } from 'rev-shared/ui/formGroup/FormGroupAngular.Module';
import { PipesAngularModule } from 'rev-shared/pipes/Pipes.AngularModule';
import { SpinnerAngularModule } from 'rev-shared/ui/spinner/SpinnerAngular.Module';
import { TabPanelModule } from 'rev-shared/ui/tabPanel/TabPanel.Module';
import { TextInputAngularModule } from 'rev-shared/ui/text-input/TextInputAngular.Module';
import { ToolbarNgxModule } from 'rev-shared/ui/toolbar/ToolbarNgx.Module';
import { VbDropdownMenuModule } from 'rev-shared/ui/dropdown-menu/VbDropdownMenu.Module';
import { VbProfilePictureModule } from 'rev-shared/ui/profile/VbProfilePicture.Module';
import { VbTextAreaModule } from 'rev-shared/ui/textArea/VbTextArea.Module';
import { VbUiHtmlEditorComponent } from 'rev-shared/htmlEditor/VbUiHtmlEditor.Component';
import { VbUiSortableModule } from 'rev-shared/ui/sortable/VbUiSortable.Module';
import { VbWebcastAskQuestionComponent } from './VbWebcastAskQuestion.Component';
import { VbWebcastAttendeeQuestionSidebarComponent } from './VbWebcastAttendeeQuestionSidebar.Component';
import { VbWebcastManageQuestionFullscreenComponent } from './VbWebcastManageQuestionFullscreen.Component';
import { VbWebcastManageQuestionSidebarComponent } from './VbWebcastManageQuestionSidebar.Component';
import { VbWebcastQuestionAttendeeCardComponent } from './VbWebcastQuestionAttendeeCard.Component';
import { VbWebcastQuestionDirectReplyComponent } from './VbWebcastQuestionDirectReply.Component';
import { VbWebcastQuestionManageCardComponent } from './VbWebcastQuestionManageCard.Component';
import { VbWebcastQuestionsListComponent } from './VbWebcastQuestionsList.Component';
import { VbWebcastQuestionsSidebarComponent } from './VbWebcastQuestionsSidebar.Component';

const components = [
	VbWebcastAskQuestionComponent,
	VbWebcastAttendeeQuestionSidebarComponent,
	VbWebcastManageQuestionFullscreenComponent,
	VbWebcastManageQuestionSidebarComponent,
	VbWebcastQuestionDirectReplyComponent,
	VbWebcastQuestionsListComponent,
	VbWebcastQuestionsSidebarComponent
];

@NgModule({
	declarations: components,
	exports: [
		VbWebcastQuestionsSidebarComponent,
		VbWebcastManageQuestionFullscreenComponent
	],
	imports: [
		BrandingAngularModule,
		BsDropdownModule,
		ButtonsAngularModule,
		CheckboxAngularModule,
		CommonModule,
		CssRulesAngularModule,
		DateAngularModule,
		DialogAngularModule,
		DirectivesAngularModule,
		FormDirectivesAngularModule,
		FormGroupAngularModule,
		FormsModule,
		PipesAngularModule,
		SpinnerAngularModule,
		TabPanelModule,
		TabsModule,
		TextInputAngularModule,
		ToolbarNgxModule,
		TooltipModule,
		TranslateModule,
		VbDropdownMenuModule,
		VbProfilePictureModule,
		VbTextAreaModule,
		VbUiHtmlEditorComponent,
		VbUiSortableModule,
		VbWebcastQuestionAttendeeCardComponent,
		VbWebcastQuestionManageCardComponent
	]
})
export class VbWebcastQuestionsModule {
	constructor(dialog: DialogRegistrationService) {
		dialog.register('vbWebcastQuestionDirectReply', {
			component: VbWebcastQuestionDirectReplyComponent
		});
	}
}
